import { settings } from '../constants';
import { get, post } from './FetchService';

class FsPlaylistService {
    constructor(){
        this.MpxPlaylist = null;
        this.parselyPlaylist = null;
    }

    getMpxPlaylist( endcard, limit, postId ) {
		if (this.MpxPlaylist) {
			return this.MpxPlaylist;
        }
        this.MpxPlaylist = get( `${settings.MPX_PLAYLIST_URL}?mpxfeed=${encodeURIComponent(endcard)}&limit=${limit}&postId=${postId}`,
        json => {
            let data = json.data;
            return Array.isArray(data) ? data : [data];
        }, () => []);
        return this.MpxPlaylist;
    }

    getParselyPlaylist( postId ) {
        if (this.parselyPlaylist) {
			return this.parselyPlaylist;
		}

		this.parselyPlaylist = get(settings.PARSELY_URL + postId,
			json => {
				if (!json.success) return [];
				let data = json.data;
				return Array.isArray(data) ? data : [data];
			},
			() => []);

		return this.parselyPlaylist;
    }
    getParselyContentByTags( parselyFeedTags = '', defaultVideoTags = '', postId = 0) {
        if (this.parselyPlaylist) {
			return this.parselyPlaylist;
		}

		let tags = '?parselytags=' + parselyFeedTags + ( defaultVideoTags && '&defaulttags=' + defaultVideoTags ) + '&postid=' + postId;
		this.parselyPlaylist = get(settings.PARSELY_URL_V2 + tags,
			json => {
				if (!json.success) return [];
				let data = json.data;
				return Array.isArray(data) ? data : [data];
			},
			() => []);

		return this.parselyPlaylist;
	}
	getParselyContentByFeed( feedUrl, postId = 0) {
        if (this.playlist) {
			return this.playlist;
		}

		let url = '?feedurl=' + encodeURIComponent( feedUrl ) + '&postid=' + postId;
		this.playlist = get(settings.PARSELY_URL_V2 + url,
			json => {
				if (!json.success) return [];
				let data = json.data;
				return Array.isArray(data) ? data : [data];
			},
			() => []);

		return this.playlist;
    }
}

export default FsPlaylistService;


// WEBPACK FOOTER //
// ./react-app-src/shared/services/FsPlaylistService.js